export const NAVIGATE = '[Layout]/NAVIGATE';
export const SET_APP_NAME = '[Layout]/SET_APP_NAME';
export const SET_VIEW_MODE = '[Layout]/SET_VIEW_MODE';
